import React, { FC, Suspense } from 'react';
import { RouteProvider, createHistory } from '@blocs.router';
import { ApolloProvider } from '@apollo/client';
import { Loading } from '@minecraft.loader';
import { NotificationProvider } from '@minecraft.notification-provider';
import { UserContextProvider } from '@blocs.auth';
import { FeatureExperimentProvider } from '@blocs.features-experiments';
import { MaintenanceGuard } from '@blocs.maintenance';
import { AppKey, InternationalizationProvider } from '@blocs.i18n';
import { PollingProvider } from '@blocs.polling';
import Routes from 'src/routes';
import createApolloClient from '@enterprise-casting.shared/apollo/create-apollo-client';
import ThemeProvider from 'shared/components/ThemeProvider/ThemeProvider';
import { slk } from 'survey-core';
import { getEnvironment } from '@minecraft.environment';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { WindowWidthContext } from '@minecraft.utils';
import { AnalyticsProvider } from '@blocs.analytics';

const App: FC = () => {
  const environment = getEnvironment();
  const apolloClient = createApolloClient();
  const history = createHistory();
  slk(getEnvironment().SURVEY_JS_LICENSE as string);

  return (
    <Suspense fallback={<Loading />}>
      <InternationalizationProvider appName={AppKey.CASTING} namespaces={['casting']}>
        <FeatureExperimentProvider>
          <RouteProvider history={history}>
            <ApolloProvider client={apolloClient}>
              <GoogleOAuthProvider clientId={environment.GOOGLE_AUTH_CLIENT_ID}>
                <UserContextProvider>
                  <AnalyticsProvider>
                    <ThemeProvider>
                      <NotificationProvider>
                        <PollingProvider>
                          <MaintenanceGuard routes={Routes} />
                        </PollingProvider>
                      </NotificationProvider>
                    </ThemeProvider>
                  </AnalyticsProvider>
                </UserContextProvider>
              </GoogleOAuthProvider>
            </ApolloProvider>
          </RouteProvider>
        </FeatureExperimentProvider>
      </InternationalizationProvider>
    </Suspense>
  );
};

export default WindowWidthContext.withWidthDataProvider(React.memo(App));
